// extracted by mini-css-extract-plugin
export var pattern = "pattern-module--pattern--4f42c";
export var patternCol4 = "pattern-module--pattern-col-4--c813e";
export var patternCol8 = "pattern-module--pattern-col-8--f67df";
export var patternDesc = "pattern-module--pattern-desc--fb554";
export var patternDescList = "pattern-module--pattern-desc-list--c05e1";
export var patternSubscr = "pattern-module--pattern-subscr--715f8";
export var patternSubscrList = "pattern-module--pattern-subscr-list--176aa";
export var patternTitle = "pattern-module--pattern-title--df66b";